import cx from 'classnames'
import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'

import './styles.scss'
import { getMyStatus } from '../layout/sidebar/alerts/utils'

const LEVEL_DURATION = 4 * 60

export const getBottomLabels = statusHistory => {
  const extractStatus = st =>
    _.first(_.filter(statusHistory, s => s.status === st))

  const formatTime = level => moment(level).format('HH:mm')

  const makeRange = (start, end, addToEnd = null) => ({
    start: _.get(start, 'start') && formatTime(start.start),
    end:
      _.get(end, 'start') &&
      (addToEnd
        ? formatTime(moment(end.start).clone().add(addToEnd[0], addToEnd[1]))
        : formatTime(end.start))
  })

  const isStartSetFor = level => !_.isEmpty(_.get(level, 'start'))

  const [ nn, l1, l2, l4, l5 ] = [ 'new', 'l1', 'l2', 'l4', 'l5' ].map(st =>
    extractStatus(st))

  if (isStartSetFor(l5)) {
    return makeRange(l1, l5)
  }

  if (isStartSetFor(l4)) {
    return makeRange(l1, l4, [ LEVEL_DURATION, 's' ])
  }

  if (isStartSetFor(l2)) {
    return makeRange(l1, l2, [ 2 * LEVEL_DURATION, 's' ])
  }

  if (isStartSetFor(nn) && !isStartSetFor(l1)) {
    return makeRange(nn, nn, [ 3 * LEVEL_DURATION, 's' ])
  }

  return makeRange(l1, l1, [ 3 * LEVEL_DURATION, 's' ])
}

export function StatusHistoryProgressBar ({
  statusHistory,
  myStatus,
  currentTime,
  startLabel,
  endLabel
}) {
  const st = getMyStatus(statusHistory, myStatus, currentTime)
  const inactive = st.state === 'inactive'

  const noStart = startLabel === null
  const noEnd = endLabel === null

  const progressbarClass = cx({
    'progressbar': true,
    'no-start': noStart,
    'no-end': noEnd,
    'no-marker': st.progress > 99 || st.progress < 2,
    'overtime': st.state === 'overtime',
    'current': st.state === 'current',
    inactive
  })

  return (
    <div className='metro-progress-bar'>
      <div className='progressbar-labels'>
        {!noStart && <h4>{startLabel}</h4>}
        {!noEnd && <h4>{endLabel}</h4>}
      </div>
      <div className={progressbarClass}>
        {!inactive && (
          <div
            className='progressbar-value'
            style={{ width: `${st.progress < 100 ? st.progress : 100}%` }}
          />
        )}
        {st.state === 'current' && (
          <div className='remaining'>{`${st.remaining}s`}</div>
        )}
      </div>
    </div>
  )
}

StatusHistoryProgressBar.propTypes = {
  statusHistory: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      start: PropTypes.string,
      end: PropTypes.string
    })
  ),
  currentTime: PropTypes.string,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string
}
